import { api } from "@/lib/api";
import { TourDayDto, tourDayDtoListSchema, tourDayFromDto } from "@/models";
import { queryOptions, useQuery } from "@tanstack/react-query";

export function getTourDaysQueryOptions(tourId: string) {
  return queryOptions({
    queryKey: ["tour-days", tourId],
    queryFn: async () => {
      const result: Array<TourDayDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.getWithCache("/api/tourdays", tourDayDtoListSchema, {
          query: {
            page: page.toString(),
          },
          filters: {
            TourId: Number.parseInt(tourId),
          },
        });
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(tourDayFromDto);
    },
  });
}

export function useGetTourDays(tourId: string) {
  return useQuery(getTourDaysQueryOptions(tourId));
}
